import React from 'react'
import ReactDOM from 'react-dom'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'

import App from './App'
import theme from './Theme'

// Renders the App
if (typeof document !== 'undefined') {
  const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate || ReactDOM.render
  const muiTheme = createMuiTheme(theme)
  const render = Comp => {
    renderMethod(
      <MuiThemeProvider theme={muiTheme}>
        <Comp />
      </MuiThemeProvider>
      , document.getElementById('root'))
  }
  render(App)
}

export default App



// WEBPACK FOOTER //
// /Users/evank/Documents/dev/kyle.ventures/src/index.js